import { Component, Input } from '@angular/core';
import { TimelineItemDto, TimelineResponseDto } from '@core/dto/avaliacao-desempenho/visualizar-servidor-timeline.dto';

@Component({
  selector: 'app-timeline-horizontal',
  templateUrl: './timeline-horizontal.component.html',
  styleUrls: [ './timeline-horizontal.component.scss' ]
})
export class TimelineHorizontalComponent {

  @Input() dadosTimeline: TimelineResponseDto;
  @Input() title: string = 'Acompanhamento:';
  @Input() dataPosse;

  getPgdi(index: number): TimelineItemDto | null {
    return this.dadosTimeline?.pgdis?.[index] || null;
  }

  getTermo(index: number): TimelineItemDto | null {
    return this.dadosTimeline?.termos?.[index] || null;
  }

  getParecer(): TimelineItemDto | null {
    return this.dadosTimeline?.parecer || null;
  }

  getOrdinalLabel(num: number): string {
    const ordinals = ['1º', '2º', '3º', '4º', '5º', '6º', '7º', '8º', '9º', '10º'];
    return ordinals[num - 1] || `${num}º`;
  }

  getIconByStatus(status: string | undefined) {
    const statusMap = {
      'Pendente': 'fa-exclamation-circle',
      'Andamento': 'fa-clock',
      'Finalizado': 'fa-check-circle'
    }

    return statusMap[status || 'Pendente'] || 'fa-exclamation-circle';
  }

  getColorButtonByStatus(status: string | undefined) {
    const statusMap = {
      'Pendente': 'pendente',
      'Andamento': 'andamento',
      'Finalizado': 'finalizado'
    }

    return statusMap[status || 'Pendente'] || 'pendente';
  }

}
